module.exports = __webpack_public_path__ + "static/media/Adobe_Photoshop_CC_icon.8ca8f89d.svg";